import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import type { WorkflowRule } from '../types';

// Guard: employee with no dealership access — redirect to role assumption flow
export const roleAssumptionRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const { isEmployee, availableDealerships = [] } = state?.salesCheckin?.dealerships ?? {};
    if (isEmployee && !availableDealerships.length) {
        return WorkflowStatus.ROLE_ASSUMPTION_REQUIRED;
    }
    return null;
};
